/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import {
    setAnotherMarket,
    setUnderwriter,
    resetQuotes,
    resetQuoteVariation,
    issueQuoteVariation
} from '../../../actions'

/**
 * Import
 * - Page component
 */
import Step05 from '../../../components/pages/Quote/Step05/Step05'

const mapStateToProps = (state: RootState, props: any) => {
    let fullquote = get(state.quote, 'full.response.quote', {})
    if (Object.keys(fullquote).length === 0) {
        fullquote = get(state.quote, 'fullRenewals.response.renewal', {})
    }
    return {
        quote: state.quote,
        subjectivities: state.step05.subjectivities,
        marketStatus: state.step05.market,
        underwriterStatus: state.step05.underwriter,
        step05: state.step05,
        stockBusinessAssets: get(state.quote, 'full.response.quote.stockBusinessAssets', {}),
        fullQuote: fullquote,
    }
}

export default connect(
    mapStateToProps,
    {
        quote: 'The QUOTE! Step02',
        setAnotherMarket: setAnotherMarket,
        setUnderwriter: setUnderwriter,
        issueQuoteVariation: issueQuoteVariation,
        resetQuotes: resetQuotes,
        resetQuoteVariation: resetQuoteVariation,
    }
)(Step05)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step05.tsx